(() => {
  const icons = document.querySelectorAll('[data-ada-button]');

  [...icons].forEach((el) => el.addEventListener('keydown', (event) => handleMenuButtonADA(event, el)));

  const handleMenuButtonADA = (event, icon) => {
    const { key, target } = event;
    if (key === 'Enter' && target == icon) {
      target.click();
    }
  };

  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      const {
        detail: { blockId }
      } = e;
      const current = document.querySelector(`[data-block-id="${blockId}"]`);
      if (current) {
        current.init();
        current.openMegaMenu();
      }
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const {
        detail: { blockId }
      } = e;
      const current = document.querySelector(`[data-block-id="${blockId}"]`);
      if (current) current.closeMegaMenu();
    });
  }
})();
